import { createContext, useContextSelector } from 'use-context-selector';

const GlobalStateCS = createContext(null);
const useGlobalStateSelector = (selector) => useContextSelector(GlobalStateCS, selector);

const words = require('./words.json');
const priceDigit = -6;
const marginOfSessionTime = 60000;
const royaltyPercentageDigit = -6;
let wallet;

const stateKeysToSetAddress = [
  ['active', 'addressMain'],
  ['configure', 'addressMain'],
  ['exhibit', 'addressMain'],
  ['purchase', 'addressMain'],
  ['permit', 'addressOwner'],
  ['requestPermission', 'addressMain'],
  ['delegate', 'addressDelegateFrom'],
  ['unregisteredAddress', 'address'],
];

const stateKeysToSetUserName = [
  ['configure', 'userName'],
];

function getInitialConfigureState(addressMain = '') {
  return {
    addressMain,
    addressCardFromDefault: '',
    addressPayProceedsToDefault: '',
    addressPayFromDefault: '',
    addressSendCardToDefault: '',
    userName: '',
    images: {
      main: null,
    },
    imagesNew: {
      main: null,
      mainUrl: null,
    },
    readTheTermsAndConditions: false,
    readPrivacyPolicy: false,
    acceptedVersionOfTheTermsAndConditions: null,
    acceptedVersionOfPrivacyPolicy: null,
    homed: false,
    profileText: '',
    displayAddressSection: false,
    mnemonic: null,
    wif: '',
    status: null,
  };
}

// SET WALLET
// wallet（Mpurse か MonaPallet か）を書き換える。ES モジュールの import は読み取り専用で、import した側（App.js）から代入すると、
// webpack の版によっては「Cannot set property wallet of #<Object> which has only a getter」で止まるので、宣言したこのファイルの中で書き換える
function setWallet({ walletName }) {
  wallet = walletName;
}

export {
  GlobalStateCS,
  useGlobalStateSelector,
  words,
  wallet,
  priceDigit,
  marginOfSessionTime,
  royaltyPercentageDigit,
  getInitialConfigureState,
  setWallet,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
};
